var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('modal',{attrs:{"prop":_vm.prop,"model_name":_vm.model_name,"model":_vm.model}}),_c('b-form-input',{attrs:{"placeholder":'Ingresar '+_vm.propText(_vm.prop)},on:{"click":_vm.showModal},model:{value:(_vm.model[_vm.prop.key]),callback:function ($$v) {_vm.$set(_vm.model, _vm.prop.key, $$v)},expression:"model[prop.key]"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }